import { getPath } from '@/router/common'

const baseUrl = {
  title: '库位管理',
  path: 'Location'
}
export default [
  {
    path: getPath('Index', baseUrl),
    name: 'Location_Index',
    component: () => import(/* webpackChunkName: "Location_Index" */ '@/views/location/index/index.vue'),
    meta: {
      title: '库位管理'
    }
  },
  {
    path: getPath('OperationRecord', baseUrl),
    name: 'Location_OperationRecord',
    component: () => import(/* webpackChunkName: "Location_OperationRecord" */ '@/views/location/operationRecord/index.vue'),
    meta: {
      title: '上下架记录'
    }
  },
  {
    path: getPath('AddOrEditWarehouse', baseUrl),
    name: 'Location_AddOrEditWarehouse',
    component: () => import(/* webpackChunkName: "Location_AddOrEditWarehouse" */ '@/views/location/addOrEditWarehouse/index.vue'),
    meta: {
      title: '新增修改'
    }
  },
  {
    path: getPath('LocationOrder', baseUrl),
    name: 'Location_LocationOrder',
    component: () => import(/* webpackChunkName: "Location_LocationOrder" */ '@/views/location/locationOrder/index.vue'),
    meta: {
      title: '库位运单明细'
    }
  }
]
